export {
  default as Notificacao
} from "./Notificacao"
export {
  default as TableNotificacao
} from "./TableNotificacao"
export {
  default as NotificacaoCreateForm
} from "./NotificacaoCreateForm"
export {
  default as NotificacaoEditForm
} from "./NotificacaoEditForm"
export {
  default as NotificacaoTrash
} from "./NotificacaoTrash"



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/notificacao/index.js